var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "not-found-pages va-row" }, [
    _c("div", { staticClass: "flex md12 xs12" }, [
      _c(
        "div",
        { staticClass: "va-row" },
        _vm._l(_vm.items, function (item) {
          return _c(
            "vuestic-card",
            {
              key: item.$index,
              staticClass: "not-found-pages__cards",
              attrs: { image: item.imageUrl },
            },
            [
              _vm._v("\n        " + _vm._s(item.label) + "\n        "),
              _c(
                "div",
                { staticClass: "not-found-pages__button-container pt-3 mb-0" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: { to: { name: item.buttonTo }, target: "_blank" },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary btn-sm not-found-pages__advanced-button",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s("View Example") +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        }),
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }